<template>
  <div>
    <!-- 邮件预览 -->
    <el-dialog title="发送邮件预览" :close-on-click-modal="false" :visible.sync="dialogVisible" width="1200px" center>
      <div class="content">
        <div v-html="content"></div>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {

  data() {
    return {
      dialogVisible: false,
      content: ''
    };
  },
  methods: {

  },
};
</script>
<style lang='scss' scoped>
.content {
  padding: 24px;
  background-color: #f8f8f8;
  border-radius: 8px;

  .title {
    text-align: center;
    margin-bottom: 20px;
    font-size: 20px;
  }

  /deep/ p {
    margin: 16px 0;
  }
}
</style>